<template>
  <div class="contents">
    <div class="d-flex section-title">
      <img src="@/assets/images/Icon advance student.png" alt="" width="25.2" height="25.2" />
      <p class="title-bk">進級管理</p>
      <button class="btn-image ml-auto">
        <img
          src="@/assets/images/Button refresh.png"
          alt=""
          width="27.3"
          height="27.3"
          @click="reloadAdvanceStudents"
        />
      </button>
    </div>

    <!--tab-->
    <ul class="nav nav-tabs">
      <li class="d-flex nav-item" id="inclass_tab_menu">
        <a class="nav-link tabitem active">
          進級待ち生徒
        </a>
      </li>
    </ul>
    <div class="container">
      <form class="d-flex form-inline">
        <button type="button" class="btn-sm" @click="clearFilteredByClass">全員を表示</button>
        <v-select
          tag="div"
          v-model="selectedTamaiClassId"
          placeholder="クラスを選択 / 検索して表示"
          class="form-control"
          id="dropdownMenuButton"
          :options="tamaiClasses"
          :reduce="(option) => option.id"
          label="nameReading"
          @input="refreshAdvanceStudents"
        />
        <div class="form-group ml-auto">
          <label for="text1">検索:</label>
          <input type="text" id="searchform_small" class="form-control" v-model="filter" />
        </div>
      </form>

      <div class="tab-content">
        <div id="table-1" class="tab-pane active">
          <div class="table-wrapper-scroll-y">
            <b-table
              ref="advance-student-table"
              :min-width="tableWidth"
              class="sticky-table table-auto-height"
              responsive
              sticky-header
              :items="filteredAdvanceStudents"
              :fields="fields"
              :filter="filter"
              :per-page="perPage"
              :current-page="currentPage"
              :busy="advanceStudentBusy"
              :refreshed="tableRefreshed()"
            >
              <template v-slot:head()="scope">
                <div class="text-nowrap">
                  <b>{{ scope.label }}</b>
                </div>
              </template>

              <template v-slot:cell(correspondence)="row">
                <div class="table-sticky-right-column">
                  <button type="button" class="btn btn-confirm" @click="checkHistory(row.item.id)">
                    学習履歴
                  </button>
                </div>
              </template>

              <template v-slot:table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>データのロード...</strong>
                </div>
              </template>
            </b-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import { sumObjectArrayByKey } from '@/utils/math_helpers.js';
import { updateTableHeight } from '@/helpers/table';
import { updateStickyColumnsAndMinWidth } from '@/helpers/sticky_table';
import { basicDate, basicFieldPresent } from '@/presenters/fields';
import map from 'lodash/map';
import uniqBy from 'lodash/uniqBy';

export default {
  data() {
    var fields = [
      {
        key: 'examDatetime',
        label: '受験日',
        sortable: true,
        enable: true,
        class: 'sticky-column left-sticky-column-1',
        thAttr: { width: 100 },
        sortByFormatted: true,
        filterByFormatted: true,
        formatter: (value) => {
          return this.examDatetimeDisplay(value);
        },
      },
      {
        key: 'name',
        label: '生徒名',
        sortable: true,
        enable: true,
        searchable: true,
        class: 'sticky-column left-sticky-column-2',
        thAttr: { width: 100 },
      },
      {
        key: 'score',
        label: '得点',
        sortable: true,
        enable: true,
        searchable: true,
        class: 'sticky-column left-sticky-column-3',
        thAttr: { width: 80 },
        sortByFormatted: true,
        filterByFormatted: true,
        formatter: (value) => {
          return value + '点';
        },
      },
      {
        key: 'book',
        label: '教材',
        sortable: true,
        enable: true,
        searchable: true,
        thAttr: { width: 170 },
        sortByFormatted: true,
        filterByFormatted: true,
        formatter: (value) => {
          return basicFieldPresent(value, 'name');
        },
      },
      {
        key: 'school',
        label: '教場名',
        sortable: true,
        enable: true,
        searchable: true,
        thAttr: { width: 100 },
        sortByFormatted: true,
        filterByFormatted: true,
        formatter: (value) => {
          return basicFieldPresent(value, 'name');
        },
      },
      {
        key: 'tamaiClass',
        label: 'クラス名',
        sortable: true,
        enable: true,
        searchable: true,
        thAttr: { width: 150 },
        sortByFormatted: true,
        filterByFormatted: true,
        formatter: (value) => {
          return basicFieldPresent(value, 'name');
        },
      },
      {
        key: 'mainTeacher',
        label: '先生名（担当メイン）',
        sortable: true,
        enable: true,
        searchable: true,
        thAttr: { width: 200 },
        sortByFormatted: true,
        filterByFormatted: true,
        formatter: (value) => {
          return basicFieldPresent(value, 'name');
        },
      },
      {
        key: 'uid',
        label: '生徒ID',
        sortable: true,
        enable: true,
        searchable: true,
        thAttr: { width: 150 },
      },
      {
        key: 'correspondence',
        label: '学習履歴',
        sortable: false,
        enable: true,
        searchable: true,
        class: 'sticky-column right-sticky-column-1',
        thAttr: { width: 150 },
      },
    ];
    return {
      fields: fields,
      currentPage: 1,
      selectAll: false,
      filter: null,
      currentAdvanceStudent: null,
      advanceStudentBusy: true,
      selectedTamaiClassId: null,
    };
  },
  computed: {
    perPage() {
      return this.totalAdvanceStudents;
    },
    tamaiClasses() {
      let tamaiClassByStudent = map(this.advanceStudents, 'tamaiClass');
      return uniqBy(tamaiClassByStudent, 'id');
    },
    filteredAdvanceStudents() {
      if (this.selectedTamaiClassId) {
        return this.advanceStudents.filter((student) => {
          return student.tamaiClass.id == this.selectedTamaiClassId;
        });
      }
      return this.advanceStudents;
    },
    filteredHeaders() {
      return this.fields.filter((field) => field.enable == true);
    },
    tableWidth() {
      return sumObjectArrayByKey(this.filteredHeaders, 'thAttr', 'width') + 'px';
    },
    ...mapState({
      advanceStudents: (state) => state.advance_student.advanceStudents,
    }),
    ...mapGetters('advance_student', ['totalAdvanceStudents', 'getAdvanceStudentById']),
  },
  mounted() {
    this.reloadAdvanceStudents();
  },
  methods: {
    tableRefreshed() {
      this.$logger.debug('Table refreshed');
      updateTableHeight();
      updateStickyColumnsAndMinWidth({
        leftColumns: 3,
        rightColumns: 1,
      });
    },
    examDatetimeDisplay(field) {
      // TODO: When we start storing time info of the test, the code below will be changed to basicDatetime(field)
      return basicDate(field);
    },
    checkHistory(id) {
      this.currentAdvanceStudent = this.getAdvanceStudentById(id);
      this.$logger.debug('Show Learning History of Student with ID :' + this.currentAdvanceStudent.studentId);
      this.$router.push({ name: 'student-id-history', params: { id: this.currentAdvanceStudent.studentId } });
    },
    reloadAdvanceStudents() {
      this.$logger.debug('Reload advance students');
      this.advanceStudentBusy = true;
      this.fetchAdvanceStudents().then(() => {
        this.advanceStudentBusy = false;
        this.refreshAdvanceStudents();
      });
    },
    refreshAdvanceStudents() {
      this.$logger.debug('Refresh table');
      this.$refs['advance-student-table'].refresh();
    },
    clearFilteredByClass() {
      this.selectedTamaiClassId = null;
      this.refreshAdvanceStudents();
    },
    ...mapActions('advance_student', ['fetchAdvanceStudents']),
  },
};
</script>

<style scoped>
.section-title {
  padding-bottom: 8px;
  max-width: 1140px;
}
.nav-tabs {
  border-width: 1px 1px 0px 1px;
  height: 46px;
  max-width: 1140px;
}
.tabitem.active {
  border-width: 1px 1px 0px 1px;
  border-color: black;
  margin-top: 16px;
  height: 30px;
}
.container {
  border-radius: 0px 0px 3px 3px;
  padding-top: 12px;
  padding-bottom: 12px;
}
.btn-image {
  padding-right: 0px;
}
.btn-sm {
  margin-left: 0px;
  margin-right: 10px;
}
.btn-confirm {
  margin: 0px;
  width: 160px;
  margin-left: 0px;
  margin-right: 10px;
  margin-bottom: 2px;
  padding: 5px 32px;
}
</style>
